"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareTenors = exports.getNoOfPeriods = exports.getLatestDateBeforeGivenDateRange = exports.constructListOfDates = exports.getNextDateByFrequencyAsFinancialDate = exports.getNextDateByFrequency = exports.frequencyTenorSuffix = exports.frequencyFromAlias = exports.Frequencies = void 0;
const financial_date_1 = require("./financial-date");
const moment_1 = require("moment");
const rounding_method_1 = require("./rounding-method");
const DATE_MOMENT_FORMAT = 'YYYY-MM-DD';
const MAX_LOOPS_ALLOWED = 1000;
class Frequencies {
    constructor() {
        this.DAILY = 'DAILY';
        this.WEEKLY = 'WEEKLY';
        this.FORTNIGHTLY = 'FORTNIGHTLY';
        this.MONTHLY = 'MONTHLY';
        this.BIMONTHLY = 'BIMONTHLY';
        this.QUARTERLY = 'QUARTERLY';
        this['SEMI-ANNUAL'] = 'SEMI-ANNUAL';
        this.ANNUAL = 'ANNUAL';
        this.ZEROCOUPON = 'ZEROCOUPON';
        this.NONE = 'NONE';
    }
}
exports.Frequencies = Frequencies;
const FREQUENCY_ALIASES = {
    DLY: 'DAILY',
    WK: 'WEEKLY',
    F: 'FORTNIGHTLY',
    MTH: 'MONTHLY',
    B: 'BIMONTHLY',
    QTR: 'QUARTERLY',
    Q: 'QUARTERLY',
    SA: 'SEMI-ANNUAL',
    H: 'SEMI-ANNUAL',
    PA: 'ANNUAL',
    D: 'DAILY',
    W: 'WEEKLY',
    M: 'MONTHLY',
    Y: 'ANNUAL',
    ZC: 'ZEROCOUPON',
};
const FREQUENCY_TENOR_SUFFIX = {
    DAILY: 'D',
    WEEKLY: 'W',
    MONTHLY: 'M',
    ANNUAL: 'Y',
};
function isValidFrequency(name) {
    const dummy = new Frequencies();
    return Object.keys(dummy).indexOf(name) > -1;
}
function frequencyFromAlias(alias) {
    alias = alias.toUpperCase();
    if (isValidFrequency(alias)) {
        return alias;
    }
    alias = FREQUENCY_ALIASES[alias];
    if (isValidFrequency(alias)) {
        return alias;
    }
    throw Error('Invalid Frequency:' + alias);
}
exports.frequencyFromAlias = frequencyFromAlias;
function frequencyTenorSuffix(frequency) {
    return FREQUENCY_TENOR_SUFFIX[frequency];
}
exports.frequencyTenorSuffix = frequencyTenorSuffix;
function getNextDateByFrequencyNoRollingDay(fromDate, frequencyToAdd, noOfTerms) {
    let dateUtilOutput;
    switch (frequencyToAdd) {
        case 'DAILY':
            dateUtilOutput = fromDate.addDays(noOfTerms);
            break;
        case 'WEEKLY':
            dateUtilOutput = fromDate.addDays(7 * noOfTerms);
            break;
        case 'FORTNIGHTLY':
            dateUtilOutput = fromDate.addDays(14 * noOfTerms);
            break;
        case 'MONTHLY':
            dateUtilOutput = fromDate.addMonths(noOfTerms);
            break;
        case 'BIMONTHLY':
            dateUtilOutput = fromDate.addMonths(2 * noOfTerms);
            break;
        case 'QUARTERLY':
            dateUtilOutput = fromDate.addMonths(3 * noOfTerms);
            break;
        case 'SEMI-ANNUAL':
            dateUtilOutput = fromDate.addMonths(6 * noOfTerms);
            break;
        case 'ANNUAL':
            dateUtilOutput = fromDate.addMonths(12 * noOfTerms);
            break;
        default:
            dateUtilOutput = fromDate;
            break;
    }
    return dateUtilOutput;
}
function getNextDateByFrequencySpecificDay(fromDate, frequencyToAdd, noOfTerms, dayOfMonth) {
    let date = fromDate;
    switch (frequencyToAdd) {
        case 'DAILY':
            date = fromDate.addDays(noOfTerms);
            break;
        case 'WEEKLY':
            date = fromDate.addDays(7 * noOfTerms);
            break;
        case 'FORTNIGHTLY':
            date = fromDate.addDays(14 * noOfTerms);
            break;
        case 'MONTHLY':
            date = fromDate.addMonths(noOfTerms).firstDayOfMonth().addDays(dayOfMonth - 1);
            break;
        case 'BIMONTHLY':
            date = fromDate.addMonths(2 * noOfTerms).firstDayOfMonth().addDays(dayOfMonth - 1);
            break;
        case 'QUARTERLY':
            date = fromDate.addMonths(3 * noOfTerms).firstDayOfMonth().addDays(dayOfMonth - 1);
            break;
        case 'SEMI-ANNUAL':
            date = fromDate.addMonths(6 * noOfTerms).firstDayOfMonth().addDays(dayOfMonth - 1);
            break;
        case 'ANNUAL':
            date = fromDate.addMonths(12 * noOfTerms).firstDayOfMonth().addDays(dayOfMonth - 1);
            break;
    }
    return date;
}
function getNextDateByFrequencyDay29Or30(fromDate, frequencyToAdd, noOfTerms, dayOfMonth) {
    let dateUtilOutput = fromDate;
    switch (frequencyToAdd) {
        case 'DAILY':
            dateUtilOutput = fromDate.addDays(noOfTerms);
            break;
        case 'WEEKLY':
            dateUtilOutput = fromDate.addDays(7 * noOfTerms);
            break;
        case 'FORTNIGHTLY':
            dateUtilOutput = fromDate.addDays(14 * noOfTerms);
            break;
        case 'MONTHLY':
            if (fromDate.firstDayOfMonth().addMonths(noOfTerms).getMonth() === 2) {
                dateUtilOutput = fromDate.firstDayOfMonth().addMonths(noOfTerms).lastDayOfMonth();
            }
            else {
                dateUtilOutput = fromDate.addMonths(noOfTerms).firstDayOfMonth().addDays(dayOfMonth - 1);
            }
            break;
        case 'BIMONTHLY':
            if (fromDate.firstDayOfMonth().addMonths(2 * noOfTerms).getMonth() === 2) {
                dateUtilOutput = fromDate.firstDayOfMonth().addMonths(2 * noOfTerms).lastDayOfMonth();
            }
            else {
                dateUtilOutput = fromDate.addMonths(2 * noOfTerms).firstDayOfMonth().addDays(dayOfMonth - 1);
            }
            break;
        case 'QUARTERLY':
            if (fromDate.firstDayOfMonth().addMonths(3 * noOfTerms).getMonth() === 2) {
                dateUtilOutput = fromDate.firstDayOfMonth().addMonths(3 * noOfTerms).lastDayOfMonth();
            }
            else {
                dateUtilOutput = fromDate.addMonths(3 * noOfTerms).firstDayOfMonth().addDays(dayOfMonth - 1);
            }
            break;
        case 'SEMI-ANNUAL':
            if (fromDate.firstDayOfMonth().addMonths(6 * noOfTerms).getMonth() === 2) {
                dateUtilOutput = fromDate.firstDayOfMonth().addMonths(6 * noOfTerms).lastDayOfMonth();
            }
            else {
                dateUtilOutput = fromDate.addMonths(6 * noOfTerms).firstDayOfMonth().addDays(dayOfMonth - 1);
            }
            break;
        case 'ANNUAL':
            if (fromDate.firstDayOfMonth().addMonths(12 * noOfTerms).getMonth() === 2) {
                dateUtilOutput = fromDate.firstDayOfMonth().addMonths(12 * noOfTerms).lastDayOfMonth();
            }
            else {
                dateUtilOutput = fromDate.addMonths(12 * noOfTerms).firstDayOfMonth().addDays(dayOfMonth - 1);
            }
            break;
    }
    return dateUtilOutput;
}
function getNextDateByFrequencyEOM(fromDate, frequencyToAdd, noOfTerms) {
    let dateUtilOutput = financial_date_1.FinancialDate.fromMoment(moment_1.utc(), true); // Why??? everything else defaults to fromDate.
    switch (frequencyToAdd) {
        case 'DAILY':
            dateUtilOutput = fromDate.addDays(noOfTerms);
            break;
        case 'WEEKLY':
            dateUtilOutput = fromDate.addDays(7 * noOfTerms);
            break;
        case 'FORTNIGHTLY':
            dateUtilOutput = fromDate.addDays(14 * noOfTerms);
            break;
        case 'MONTHLY':
            dateUtilOutput = fromDate.addMonths(noOfTerms).lastDayOfMonth();
            break;
        case 'BIMONTHLY':
            dateUtilOutput = fromDate.addMonths(2 * noOfTerms).lastDayOfMonth();
            break;
        case 'QUARTERLY':
            dateUtilOutput = fromDate.addMonths(3 * noOfTerms).lastDayOfMonth();
            break;
        case 'SEMI-ANNUAL':
            dateUtilOutput = fromDate.addMonths(6 * noOfTerms).lastDayOfMonth();
            break;
        case 'ANNUAL':
            dateUtilOutput = fromDate.addMonths(12 * noOfTerms).lastDayOfMonth();
            break;
    }
    return dateUtilOutput;
}
function getNextDateByFrequency(inputDate, frequencyToAdd, noOfTerms, dayOfMonth) {
    let outputDate;
    const fromDate = financial_date_1.FinancialDate.fromString(inputDate);
    switch (dayOfMonth) {
        case 'NONE':
            outputDate = getNextDateByFrequencyNoRollingDay(fromDate, frequencyToAdd, noOfTerms);
            break;
        case 'EOM':
            outputDate = getNextDateByFrequencyEOM(fromDate, frequencyToAdd, noOfTerms);
            break;
        case '31':
            outputDate = getNextDateByFrequencyEOM(fromDate, frequencyToAdd, noOfTerms);
            break;
        case '29':
            outputDate = getNextDateByFrequencyDay29Or30(fromDate, frequencyToAdd, noOfTerms, parseInt(dayOfMonth));
            break;
        case '30':
            outputDate = getNextDateByFrequencyDay29Or30(fromDate, frequencyToAdd, noOfTerms, parseInt(dayOfMonth));
            break;
        default:
            outputDate = getNextDateByFrequencySpecificDay(fromDate, frequencyToAdd, noOfTerms, parseInt(dayOfMonth));
            break;
    }
    return outputDate.getDateString();
}
exports.getNextDateByFrequency = getNextDateByFrequency;
function getNextDateByFrequencyAsFinancialDate(fromDate, frequencyToAdd, noOfTerms, dayOfMonth) {
    let outputDate;
    switch (dayOfMonth) {
        case 'NONE':
            outputDate = getNextDateByFrequencyNoRollingDay(fromDate, frequencyToAdd, noOfTerms);
            break;
        case 'EOM':
            outputDate = getNextDateByFrequencyEOM(fromDate, frequencyToAdd, noOfTerms);
            break;
        case '31':
            outputDate = getNextDateByFrequencyEOM(fromDate, frequencyToAdd, noOfTerms);
            break;
        case '29':
            outputDate = getNextDateByFrequencyDay29Or30(fromDate, frequencyToAdd, noOfTerms, parseInt(dayOfMonth));
            break;
        case '30':
            outputDate = getNextDateByFrequencyDay29Or30(fromDate, frequencyToAdd, noOfTerms, parseInt(dayOfMonth));
            break;
        default:
            outputDate = getNextDateByFrequencySpecificDay(fromDate, frequencyToAdd, noOfTerms, parseInt(dayOfMonth));
            break;
    }
    return outputDate;
}
exports.getNextDateByFrequencyAsFinancialDate = getNextDateByFrequencyAsFinancialDate;
function constructListOfDates(startDate, endDate, interval, fromEnd, dayOfMonth, includeStart, includeEnd, periodSize) {
    const outputDates = [];
    let firstDate = financial_date_1.FinancialDate.fromString(startDate);
    let lastDate = financial_date_1.FinancialDate.fromString(endDate);
    let periodMultiplier = 1;
    if (periodSize) {
        periodMultiplier = periodSize;
    }
    if (fromEnd) {
        if (!includeEnd) {
            lastDate = getNextDateByFrequencyAsFinancialDate(lastDate, interval, -1 * periodMultiplier, dayOfMonth);
        }
        if (includeStart) {
            let loopCheck = 0;
            while (lastDate.isSameOrAfter(firstDate) && loopCheck) {
                outputDates.push(lastDate);
                lastDate = getNextDateByFrequencyAsFinancialDate(lastDate, interval, -1 * periodMultiplier, dayOfMonth);
                loopCheck++;
                if (loopCheck > MAX_LOOPS_ALLOWED) {
                    throw new Error(`constructListOfDates() exceeded max loops allowed. Possible infinite loop.`);
                }
            }
        }
        else {
            let loopCheck = 0;
            while (lastDate.isAfter(firstDate)) {
                outputDates.push(lastDate);
                lastDate = getNextDateByFrequencyAsFinancialDate(lastDate, interval, -1 * periodMultiplier, dayOfMonth);
                loopCheck++;
                if (loopCheck > MAX_LOOPS_ALLOWED) {
                    throw new Error(`constructListOfDates() exceeded max loops allowed. Possible infinite loop.`);
                }
            }
        }
        outputDates.reverse(); // should return it sorted
    }
    else {
        if (!includeStart) {
            firstDate = getNextDateByFrequencyAsFinancialDate(firstDate, interval, periodMultiplier, dayOfMonth);
        }
        // outputDates.push(firstDate);
        if (includeEnd) {
            let loopCheck = 0;
            while (lastDate.isSameOrAfter(firstDate)) {
                outputDates.push(firstDate);
                firstDate = getNextDateByFrequencyAsFinancialDate(firstDate, interval, periodMultiplier, dayOfMonth);
                loopCheck++;
                if (loopCheck > MAX_LOOPS_ALLOWED) {
                    throw new Error(`constructListOfDates() exceeded max loops allowed. Possible infinite loop.`);
                }
            }
        }
        else {
            let loopCheck = 0;
            while (lastDate.isAfter(firstDate)) {
                outputDates.push(firstDate);
                firstDate = getNextDateByFrequencyAsFinancialDate(firstDate, interval, periodMultiplier, dayOfMonth);
                loopCheck++;
                if (loopCheck > MAX_LOOPS_ALLOWED) {
                    throw new Error(`constructListOfDates() exceeded max loops allowed. Possible infinite loop.`);
                }
            }
        }
    }
    return outputDates;
}
exports.constructListOfDates = constructListOfDates;
function getLatestDateBeforeGivenDateRange(startDate, endDate, interval, fromEnd, dayOfMonth, periodSize) {
    let firstDate = financial_date_1.FinancialDate.fromString(startDate);
    let lastDate = financial_date_1.FinancialDate.fromString(endDate);
    let periodMultiplier = 1;
    if (periodSize) {
        periodMultiplier = periodSize;
    }
    let outputDate;
    if (fromEnd) {
        switch (dayOfMonth) {
            case 'NONE':
                outputDate = getNextDateByFrequencyNoRollingDay(lastDate, interval, -1 * periodMultiplier);
                break;
            case 'EOM':
                outputDate = getNextDateByFrequencyEOM(lastDate, interval, -1 * periodMultiplier);
                break;
            case '29':
                outputDate = getNextDateByFrequencyDay29Or30(lastDate, interval, -1 * periodMultiplier, parseInt(dayOfMonth));
                break;
            case '30':
                outputDate = getNextDateByFrequencyDay29Or30(lastDate, interval, -1 * periodMultiplier, parseInt(dayOfMonth));
                break;
            default:
                outputDate = getNextDateByFrequencySpecificDay(lastDate, interval, -1 * periodMultiplier, parseInt(dayOfMonth));
                break;
        }
    }
    else {
        switch (dayOfMonth) {
            case 'NONE':
                outputDate = getNextDateByFrequencyNoRollingDay(firstDate, interval, periodMultiplier);
                break;
            case 'EOM':
                outputDate = getNextDateByFrequencyEOM(firstDate, interval, periodMultiplier);
                break;
            case '29':
                outputDate = getNextDateByFrequencyDay29Or30(firstDate, interval, periodMultiplier, parseInt(dayOfMonth));
                break;
            case '30':
                outputDate = getNextDateByFrequencyDay29Or30(firstDate, interval, periodMultiplier, parseInt(dayOfMonth));
                break;
            default:
                outputDate = getNextDateByFrequencySpecificDay(firstDate, interval, periodMultiplier, parseInt(dayOfMonth));
                break;
        }
    }
    return outputDate.getDateString();
}
exports.getLatestDateBeforeGivenDateRange = getLatestDateBeforeGivenDateRange;
function getNoOfPeriods(startDate, endDate, tenor, monthEnd) {
    let noOfPeriods = 0;
    if (monthEnd) {
        startDate = startDate.lastDayOfMonth();
    }
    const rounding = rounding_method_1.Rounding.getRounding('UP', 0);
    switch (tenor) {
        case 'DAILY':
            noOfPeriods = endDate.getDaysDiff(startDate, true);
            break;
        case 'WEEKLY':
            noOfPeriods = rounding.round((endDate.getDaysDiff(startDate)) / 7);
            break;
        case 'MONTHLY':
            noOfPeriods = rounding.round(endDate.getMonthDiff(startDate, false));
            break;
        case 'ANNUAL':
            noOfPeriods = rounding.round((endDate.getMonthDiff(startDate, false) / 12));
            break;
    }
    return noOfPeriods;
}
exports.getNoOfPeriods = getNoOfPeriods;
function compareTenors(tenorA, tenorB) {
    const tenors = ['D', 'W', 'M', 'Y'];
    if (tenorA === tenorB) {
        return 0;
    }
    if (tenorA === undefined) {
        return -1;
    }
    if (tenorB === undefined) {
        return 1;
    }
    const aSuffix = tenorA.slice(-1);
    const bSuffix = tenorB.slice(-1);
    if (aSuffix === bSuffix) {
        const aPrefix = parseInt(tenorA.slice(0, -1));
        const bPrefix = parseInt(tenorB.slice(0, -1));
        return aPrefix - bPrefix;
    }
    else {
        return (tenors.indexOf(aSuffix) - tenors.indexOf(bSuffix));
    }
}
exports.compareTenors = compareTenors;
//# sourceMappingURL=frequency.js.map